import React from 'react';
import {
  Card,
  FormControlLabel,
  Grid,
  Typography
} from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import GreenCheckbox from './GreenCheckbox';


const RequestPromotionActiveDates = ({
  values,
  handleChange,
  setFieldValue,
  touched,
  errors,
  classes
}) => {
  const date = new Date();

  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-5">
        Active Dates <span className="text-error">*</span>
      </Typography>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div className="mb-2 text-muted">Start Date</div>
              <DatePicker
                autoOk
                disablePast
                variant="inline"
                format="MM/dd/yyyy"
                name="dates.startDate"
                placeholder={date.toLocaleDateString()}
                className={classes.custom_datepicker}
                value={values.dates.startDate}
                onChange={(date) => setFieldValue('dates.startDate', date)}
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted ml-2" />
                  )
                }}
                error={touched.dates?.startDate && Boolean(errors.dates?.startDate)}
                helperText={touched.dates?.startDate && errors.dates?.startDate}
              />
            </Grid>
          </Grid>
          {values.dates.isEndDates &&
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div className="mb-2 text-muted">End Date</div>
              <DatePicker
                autoOk
                disablePast
                variant="inline"
                format="MM/dd/yyyy"
                name="dates.endDate"
                error={values.dates.endDate < values.dates.startDate}
                helperText={values.dates.endDate < values.dates.startDate && 'End Date cant be less than Start Date'}
                placeholder={date.toLocaleDateString()}
                className={classes.custom_datepicker}
                value={values.dates.endDate}
                onChange={(date) => setFieldValue('dates.endDate', date)}
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted ml-2" />
                  )
                }}
              />
            </Grid>
          </Grid>
          }
        </>
      </MuiPickersUtilsProvider>
      <FormControlLabel
        control={
          <GreenCheckbox
            name="dates.isEndDates"
            checked={values.dates.isEndDates}
            onChange={handleChange}
          />
        }
        label="Set End Date"
        className="mt-5"
      />
    </Card>
  );
};

export default RequestPromotionActiveDates;
